import CallTranscriptionEntity from "../../domain/entities/call_transcription.entity";

const fromJSON = (json: any): CallTranscriptionEntity => {
    return {
        conversation: json.map((message: any)=> {
            return {
                senderIsClient: message.speaker === "Customer",
                transcription: message.text,
                time: Math.floor(message.start),
            }
        })
    }
}

const CallTranscriptionDto = {
    fromJSON,
};

export default CallTranscriptionDto;